<div class="modal-container">
  <div class="modal-header">
    <h3>Edit project</h3>
    <button type="button" class="modal-close" aria-label="Close" (click)="cancel()">
      <span class="material-icons" translate="no">close</span>
    </button>
  </div>

  <div class="modal-body">
    <form class="project-form" [formGroup]="projectForm" (ngSubmit)="save()">
      <div class="form-field-container">
        <label for="edit-project-name" class="form-field-label">Project name *</label>
        <mat-form-field
          class="gingr-input-wrapper compact-field w-full"
          appearance="outline"
          subscriptSizing="dynamic"
        >
          <input
            id="edit-project-name"
            matInput
            placeholder="Enter project name"
            type="text"
            formControlName="name"
            autocomplete="off"
          />
          @if (projectForm.controls.name.invalid && projectForm.controls.name.touched) {
            <mat-error>Project name is required</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-field-container">
        <label for="edit-project-description" class="form-field-label">Description</label>
        <mat-form-field
          class="gingr-input-wrapper compact-field compact-field--textarea w-full"
          appearance="outline"
          subscriptSizing="dynamic"
        >
          <textarea
            id="edit-project-description"
            matInput
            formControlName="description"
            rows="3"
            placeholder="Optional — shown on the project overview"
          ></textarea>
        </mat-form-field>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button mat-stroked-button type="button" class="action-btn" (click)="cancel()">Cancel</button>
    <button
      mat-raised-button
      color="accent"
      type="button"
      class="action-btn"
      [disabled]="projectForm.invalid"
      (click)="save()"
    >
      Save
    </button>
  </div>
</div>
